module.exports = __webpack_public_path__ + "static/media/capstone_permissions.fb5e24d9.yaml";